import tw from "twin.macro";
import styled from "styled-components";

export const BoxForm = styled.form`
  ${tw`mt-[1.4vw] relative bg-white z-20 mx-auto`}
  width: 597px;
  padding: 40px 32px 44px;
  border: 1px solid rgba(158, 160, 165, 0.45);
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.15);
  border-radius: 4px;

  strong {
    color: #3e3f42;
  }

  @media screen and (max-height: 1079px) {
    margin-top: 6.65rem;
    margin-bottom: 6rem;
  }

  @media screen and (max-width: 48rem) {
    width: 80vw;
    padding: 2.875rem 4vw 3.65rem;
  }

  @media screen and (max-width: 30rem) {
    margin-top: 3rem;
    width: calc(100vw - 0.875rem * 2);
    padding: 2.875rem 4vw 3.65rem;
  }
`;

export const BoxHeadline = styled.h4`
  ${tw`text-center block mx-auto`}
  font-family: "circular-std", sans-serif;
  font-weight: 600;
  color: #3e3f42;
`;

export const DescHeadline = styled.p`
  ${tw`text-center mx-auto`}
  max-width: 85%;

  @media screen and (max-width: 30rem) {
    margin: 0 auto 28px;
    max-width: 80vw;
    padding-bottom: 0;
  }
`;

export const InputForm = styled.div`
  ${tw`flex flex-col mb-[18px]`}

  label {
    ${tw`text-[14.4px] mb-2`}
    font-family: "circular-std", sans-serif;
    font-weight: 500;
  }

  input {
    padding: 15px 16px;
    border-radius: 4px;
    border: 1px solid #a0a1a6;
    font-size: 16px;
    transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);

    &::placeholder {
      color: #a0a1a6;
    }

    &:focus,
    &:active {
      outline: none;
      border: 1px solid #2d983d;
    }
  }
`;

export const ForgotPasswordLink = styled.a`
  ${tw`text-[14.4px] mb-0 pb-0`}
  color: #1964d9;
`;

export const AlternativeOption = styled.p`
  ${tw`mb-0 pb-0`}
  font-family: "circular-std", sans-serif;
  font-weight: 400;

  @media screen and (max-width: 30rem) {
    font-size: 14.4px;
    text-align: center;
  }

  a {
    ${tw`font-medium`}
    color: #1964d9;
  }
`;

export const Divider = styled.hr`
  margin-top: 1.75rem;
  margin-bottom: 1rem;
  border-color: #eaedf3;
`;

export const WButton = styled.input`
  ${tw`w-full uppercase cursor-pointer text-white border-0`}
  font-family: "circular-std", sans-serif;
  font-weight: 500;
  padding-top: 1rem;
  padding-bottom: 1rem;
  background: #33aa44;
  border-radius: 3px;
  letter-spacing: 0.6px;
  margin-top: 1.25rem;
  outline: none;
  transition: all 420ms cubic-bezier(0.165, 0.84, 0.44, 1);

  &:hover,
  &:active {
    cursor: pointer;
    background: #2d983d;
  }

  @media screen and (max-width: 30rem) {
    margin-top: 1.125rem;
    font-size: 0.875rem;
    padding-top: 14px;
    padding-bottom: 14px;
  }
`;
